import * as React from 'react';
import { Grid, Box, FormControl, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, TextField, Stack, Button, CircularProgress } from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { url, urlLive } from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

function NewRequest() {
    const [type, setType] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [company, setCompany] = React.useState('');
    const [location, setLocation] = React.useState('');
    const [experienceYears, setExperienceYears] = React.useState('');
    const [dailyRate, setDailyRate] = React.useState('');
    const [fullRemote, setFullRemote] = React.useState(false);
    const [longTerm, setLongTerm] = React.useState(false);
    const [dateStart, setDateStart] = React.useState(null);
    const [dateEnd, setDateEnd] = React.useState(null);
    const [publishDate, setPublishDate] = React.useState(null);
    const [title, setTitle] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [successMessage, setSuccessMessage] = React.useState('');
    const [companies, setCompanies] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [requestTypes, setRequestTypes] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);


    // Fetch company and category options
    React.useEffect(() => {
        fetchCompanies();
        fetchCategories();
        fetchRequestTypes();
    }, []);

    const fetchCompanies = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${url}auth/get-companies`);
            const data = await response.json();
            setCompanies(data.companies || []);

        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCategories = async () => {

        try {
            setIsLoading(true);
            const response = await fetch(`${url}auth/request-categories`);
            const data = await response.json();
            setCategories(data.categories || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setIsLoading(false);
        }

    };

    const fetchRequestTypes = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${url}auth/get-request-types`);
            const data = await response.json();
            setRequestTypes(data.data || []);
        } catch (error) {
            console.error("Error fetching request types:", error);
        } finally {
            setIsLoading(false);
        }

    };

    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const handleCategoryChange = (event) => {
        setCategory(event.target.value);
    };

    const handleCompanyChange = (event) => {
        setCompany(event.target.value);
    };

    const handleDateStartChange = (newValue) => {
        setDateStart(newValue);
    };

    const handleDateEndChange = (newValue) => {
        setDateEnd(newValue);
    };

    const handlePublishDateChange = (newValue) => {
        setPublishDate(newValue);
    };

    // Event Handlers
    const handleChange = (setter) => (event) => setter(event.target.value);
    const handleCheckboxChange = (setter) => (event) => setter(event.target.checked);

    // Form validation
    const validateForm = () => {
        const newErrors = {};

        // Validate required fields
        if (!title) newErrors.title = "Titolo è obbligatorio.";
        if (!company) newErrors.company = "Azienda è obbligatorio.";
        if (!category) newErrors.category = "Categoria è obbligatorio.";
        if (!type) newErrors.type = "Tipologia è obbligatorio.";
        if (!location) newErrors.location = "Location è obbligatorio.";
        if (!experienceYears || experienceYears <= 0) newErrors.experienceYears = "Experience Years must be a positive number.";
        if (!dailyRate || dailyRate <= 0) newErrors.dailyRate = "Daily Rate must be a positive number.";
        if (!dateStart) newErrors.dateStart = "Data inizio prevista è obbligatorio.";
        if (!dateEnd) newErrors.dateEnd = "Data fine prevista è obbligatorio.";
        if (!description) newErrors.description = "Descrizione è obbligatorio.";
        if (!longTerm) newErrors.description = "Lungo termine è obbligatorio.";
        if (!fullRemote) newErrors.description = "Full Remote è obbligatorio.";

        return Object.keys(newErrors).length === 0 ? true : newErrors;
    };

    // Handle submit
    const handleSubmit = () => {
        // Validate form before submission
        const validation = validateForm();
        if (validation !== true) {
            const errorMessage = Object.values(validation)[0];
            alert(errorMessage);
            return;
        }

        // Here you can make an API call or do whatever you'd like

        setIsSubmitting(true);
        setErrorMessage('');
        setSuccessMessage('');

        // Create FormData
        const formdata = new FormData();
        formdata.append("Title", title);
        formdata.append("Description", description);
        formdata.append("IdCompany", company);
        formdata.append("IdCategoryRequest", category);
        formdata.append("IdTypeRequest", type);
        formdata.append("Location", location);
        formdata.append("FullRemote", fullRemote ? "1" : "0");
        formdata.append("ExperienceYears", experienceYears);
        formdata.append("DailyRate", dailyRate);
        formdata.append("DateStartAvailable", dateStart ? dateStart.format('YYYY-MM-DD') : '');
        formdata.append("DateEndAvailable", dateEnd ? dateEnd.format('YYYY-MM-DD') : '');
        formdata.append("LongTerm", longTerm ? "1" : "0");
        formdata.append("PublishDate", publishDate ? publishDate.format('YYYY-MM-DD') : '');

        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };

        fetch(`${url}auth/create-requests`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setIsSubmitting(false);
                if (result.message === "Request created successfully.") {
                    setSuccessMessage('Request created successfully!');

                    // Reset the form to initial state
                    setType('');
                    setCategory('');
                    setCompany('');
                    setLocation('');
                    setExperienceYears('');
                    setDailyRate('');
                    setFullRemote(false);
                    setLongTerm(false);
                    setDateStart(null);
                    setDateEnd(null);
                    setPublishDate(null);
                    setTitle('');
                    setDescription('');


                } else if (result.error && result.messages) {
                    // Check for validation errors
                    let errorMessage = 'Please fix the following errors:\n';
                    Object.entries(result.messages).forEach(([field, messages]) => {
                        messages.forEach((msg) => {
                            errorMessage += `- ${msg}\n`;
                        });
                    });
                    alert(errorMessage);  // Show the validation error messages in an alert
                } else {
                    setErrorMessage('Failed to create request. Please try again.');
                }
            })
            .catch((error) => {
                setIsSubmitting(false);
                setErrorMessage('An error occurred while creating the request.');
                console.error(error);
            });


    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox style={{ backgroundColor: 'white' }} py={2}>
                <MDBox px={5} mx={2} mt={2}>
                    <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
                        <Grid item xs={12}>
                            <MDBox mb={1}>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        backgroundColor: 'lightgray',
                                        padding: 2,
                                        borderRadius: 1,
                                        '& .MuiGrid-item': {
                                            paddingLeft: '2px',
                                            paddingTop: '2px',
                                        },
                                    }}
                                >
                                    <Grid item xs={12} md={6} lg={4}>
                                        <MDTypography variant="h4" fontWeight="regular" color="text">
                                            New Request
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </Grid>

                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Title"
                                            variant="outlined"
                                            value={title}
                                            onChange={handleChange(setTitle)}
                                        />
                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="company-select-label">Company</InputLabel>
                                        {/* <Select
                                            labelId="company-select-label"
                                            id="company-select"
                                            value={company}
                                            label="Company"
                                            onChange={handleCompanyChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={22}>Company 1</MenuItem>
                                            <MenuItem value={23}>Company 2</MenuItem>
                                            <MenuItem value={24}>Company 3</MenuItem>
                                        </Select> */}

                                        <Select
                                            labelId="company-select-label"
                                            id="company-select"
                                            value={company}
                                            label="Company"
                                            onChange={handleCompanyChange}
                                            style={{ height: 45 }}
                                            sx={{
                                                '& .MuiSelect-icon': {
                                                    display: 'block !important',  // Force icon to be visible
                                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                                },
                                            }}
                                            IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                                        >
                                            {isLoading ? (
                                                <MenuItem disabled>
                                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                                    Loading...
                                                </MenuItem>
                                            ) : companies.length > 0 ? (
                                                companies.map((comp) => (
                                                    <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                                                        {comp.CompanyName}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No companies available</MenuItem>
                                            )}
                                        </Select>

                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="category-select-label">Category</InputLabel>
                                        {/* <Select
                                            labelId="category-select-label"
                                            id="category-select"
                                            value={category}
                                            label="Category"
                                            onChange={handleCategoryChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={43}>Category 1</MenuItem>
                                            <MenuItem value={44}>Category 2</MenuItem>
                                            <MenuItem value={45}>Category 3</MenuItem>
                                        </Select> */}

                                        <Select
                                            labelId="category-select-label"
                                            id="category-select"
                                            value={category}
                                            label="Category"
                                            onChange={handleCategoryChange}
                                            style={{ height: 45 }}
                                            sx={{
                                                '& .MuiSelect-icon': {
                                                    display: 'block !important',  // Force icon to be visible
                                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                                },
                                            }}
                                            IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                                        >
                                            {isLoading ? (
                                                <MenuItem disabled>
                                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                                    Loading...
                                                </MenuItem>
                                            ) : categories.length > 0 ? (
                                                categories.map((cat) => (
                                                    <MenuItem key={cat.IdRequestCategory} value={cat.IdRequestCategory}>
                                                        {cat.RequestCategory}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No categories available</MenuItem>
                                            )}
                                        </Select>

                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={3}>
                                    <FormControl fullWidth>
                                        <InputLabel id="type-select-label">Request Type</InputLabel>
                                        {/* <Select
                                            labelId="type-select-label"
                                            id="type-select"
                                            value={type}
                                            label="Request Type"
                                            onChange={handleTypeChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={21}>Type 1</MenuItem>
                                            <MenuItem value={22}>Type 2</MenuItem>
                                            <MenuItem value={23}>Type 3</MenuItem>
                                        </Select> */}

                                        <Select
                                            labelId="type-select-label"
                                            id="type-select"
                                            value={type}
                                            label="Request Type"
                                            onChange={handleTypeChange}
                                            style={{ height: 45 }}
                                            sx={{
                                                '& .MuiSelect-icon': {
                                                    display: 'block !important',  // Force icon to be visible
                                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                                },
                                            }}
                                            IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                                        >
                                            {isLoading ? (
                                                <MenuItem disabled>
                                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                                    Loading...
                                                </MenuItem>
                                            ) : requestTypes.length > 0 ? (
                                                requestTypes.map((type) => (
                                                    <MenuItem key={type.IdRequestType} value={type.IdRequestType}>
                                                        {type.RequestType}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>No request types available</MenuItem>
                                            )}
                                        </Select>

                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    label="Start Available"
                                                    value={dateStart}
                                                    onChange={handleDateStartChange}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    label="End Available"
                                                    value={dateEnd}
                                                    onChange={handleDateEndChange}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <TextField
                                        fullWidth
                                        label="Location"
                                        variant="outlined"
                                        value={location}
                                        onChange={handleChange(setLocation)}
                                    />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <TextField
                                        fullWidth
                                        label="Experience Years"
                                        variant="outlined"
                                        type="number"
                                        value={experienceYears}
                                        onChange={handleChange(setExperienceYears)}
                                    />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <TextField
                                        fullWidth
                                        label="Daily Rate"
                                        variant="outlined"
                                        type="number"
                                        value={dailyRate}
                                        onChange={handleChange(setDailyRate)}
                                    />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={fullRemote}
                                                onChange={handleCheckboxChange(setFullRemote)}
                                            />}
                                        label="Full Remote"
                                    />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={longTerm}
                                                onChange={handleCheckboxChange(setLongTerm)}
                                            />}
                                        label="Long Term"
                                    />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <MDBox mt={2}>
                                    <FormControl fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label="Publish Date"
                                                value={publishDate}
                                                onChange={handlePublishDateChange}
                                                sx={{ width: '100%' }}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12}>
                                <MDBox mt={3}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Description"
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            value={description}
                                            onChange={handleChange(setDescription)}
                                        />
                                    </FormControl>
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} >
                                <MDBox mt={3}>
                                    <Stack spacing={2} mb={2} direction="row" justifyContent="flex-end">
                                        <Button variant="contained" onClick={handleSubmit}>
                                            {isSubmitting ? <a style={{ color: 'white' }}>Submitting...</a> : <a style={{ color: 'white' }}>Save</a>}

                                        </Button>
                                    </Stack>
                                </MDBox>
                            </Grid>
                        </Grid>

                        {/* Display Success/Error Messages */}
                        {successMessage && (
                            <Grid item xs={12}>
                                <MDBox mt={3} style={{ color: 'green' }}>
                                    <MDTypography>{successMessage}</MDTypography>
                                </MDBox>
                            </Grid>
                        )}
                        {errorMessage && (
                            <Grid item xs={12}>
                                <MDBox mt={3} style={{ color: 'red' }}>
                                    <MDTypography>{errorMessage}</MDTypography>
                                </MDBox>
                            </Grid>
                        )}

                    </Grid>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );

}

export default NewRequest;
